/* ================================================================
   WEBBEE GEOLOCATION - EXTERNAL API LOGIC (GENERIC)
   ================================================================
   This file handles:
   1. Building the cart collection map
   2. Fetching the visitor's country code
   3. Calling the Webbee geolocation API to get location-aware inventory
   4. Updating the idquantity map with geo-adjusted quantities
   5. Signaling readiness via markGeolocationDataLoaded()

   REQUIRED GLOBALS (set by webbee_product_geolocation_generic.liquid):
   - varintsShopifyStore  (comma-separated cart SKUs)
   - variantSku           (all variant SKUs as a string)
   - domainName           (shop.permanent_domain)
   - webbeeSku            (current product's selected SKU)
   - idquantity           (Map: SKU -> quantity, updated by this file)
   - page                 (page type, e.g. "listpage")
   - soldOutGeoLocation   (function, called after API response)
   - markGeolocationDataLoaded (function, signals data ready)
   ================================================================ */


/* ================================================================
   SECTION 1: CART DATA MAP
   ================================================================ */
const collectionMap = new Map();
let shopifyQty1 = varintsShopifyStore;
shopifyQty1.split(",").map(res => {
  let sp = res.split("/");
  collectionMap.set(sp[0], sp[1]);
});


/* ================================================================
   SECTION 2: INITIALIZATION CONTROL
   ================================================================
   Ensures both DOM and country code are ready before calling the API.
   ================================================================ */
let countryCodeTemp = "";
let domReady = false;
let countryCodeFetched = false;

function tryInitialize() {
  if (domReady && countryCodeFetched) {
    initializeWebbeeGeolocation();
  }
}


/* ================================================================
   SECTION 3: COUNTRY CODE DETECTION
   ================================================================
   Fetches the visitor's country code from ipapi.co.
   Falls back to empty string if the service is unavailable.
   ================================================================ */
fetch('https://ipapi.co/country/')
  .then(response => response.text())
  .then(code => {
    countryCodeTemp = code;
  })
  .catch(() => {
    countryCodeTemp = "";
  })
  .finally(() => {
    countryCodeFetched = true;
    tryInitialize();
  });


/* ================================================================
   SECTION 4: WEBBEE GEOLOCATION API CALL
   ================================================================
   Sends all variant SKUs + shop domain + country code to the
   Webbee server. On success, overwrites the idquantity map with
   location-specific quantities.

   Response cases:
   - success + data  → update idquantity per-SKU
   - fail + geoLocationZeroInventory=Yes → set 'zero inventory' flag
   - other → keep existing Shopify quantities
   ================================================================ */
function webbeeGeolocation19(variantSku, domainName) {
  console.log("webbeeGeolocation19 called with variantSku: " + variantSku + ", domainName: " + domainName + ", countryCode: " + countryCodeTemp);
  let encodedValues = encodeURIComponent(JSON.stringify({
    "variantSKUList": variantSku,
    "domainName": domainName,
    "countryCode": countryCodeTemp
  }));
  $.ajax({
    type: 'GET',
    url: 'https://hooks.webbeeglobal.com/ShopifyAmazonFBAConnecotr/shopify/location-qty',
    async: false,
    dataType: 'jsonp',
    jsonp: 'callback',
    jsonpCallback: 'callback',
    data: encodedValues,
    success: function(callback) {
      console.log("webbeeGeolocation19 status: " + callback['status']
        + " geoLocationZeroInventory: " + callback['geoLocationZeroInventory']);

      if (callback['status'] == 'success' && callback['data'].length > 0) {
        // Case 1: Success — update idquantity with geo-adjusted quantities
        var responseFromServer = callback['data'];
        console.log("webbeeGeolocation19 response: " + responseFromServer);
        for (let i = 0; i < responseFromServer.length; i++) {
          let object = responseFromServer[i];
          idquantity.set(object['variantSKU'], object['quantity']);
        }

        try {
          if (page === "listpage") {
            soldOutGeoLocation();
          }
        } catch (exception) {
        }

        let qty = idquantity.get(webbeeSku);
        // NOTE: Button enable/disable for product page is handled by
        // the liquid snippet's commonCode() via the onGeolocationDataReady callback.

      } else if (callback['status'] == 'fail' && callback['geoLocationZeroInventory'] == 'Yes') {
        // Case 2: No inventory at this location
        idquantity.set('zero inventory', true);
      } else {
        // Case 3: Other response — keep existing Shopify quantities
        let qty = idquantity.get(webbeeSku);
      }

      // Signal that geolocation data is ready
      if (typeof markGeolocationDataLoaded === 'function') {
        markGeolocationDataLoaded();
      }
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error("webbeeGeolocation19 error: " + textStatus);
      // Even on error, mark as loaded so page doesn't hang
      if (typeof markGeolocationDataLoaded === 'function') {
        markGeolocationDataLoaded();
      }
    }
  });
}


/* ================================================================
   SECTION 5: INITIALIZATION
   ================================================================
   Calls webbeeGeolocation19 once both DOM and country code are ready.
   ================================================================ */
function initializeWebbeeGeolocation() {
  webbeeGeolocation19(variantSku, domainName);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    domReady = true;
    tryInitialize();
  });
} else {
  domReady = true;
  tryInitialize();
}
